import CardTab from './CardTab';

export default CardTab;
